import { render, staticRenderFns } from "./ChangguanCountAndMjStatBlock.vue?vue&type=template&id=bda90956&scoped=true"
import script from "./ChangguanCountAndMjStatBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanCountAndMjStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangguanCountAndMjStatBlock.vue?vue&type=style&index=0&id=bda90956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda90956",
  null
  
)

export default component.exports